import React from "react";

import { Box } from "@mui/material";

interface Props {
  all?: number | string;
  horizontal?: number | string;
  vertical?: number | string;
  top?: number | string;
  right?: number | string;
  bottom?: number | string;
  left?: number | string;
}

const Padding: React.FC<Props> = ({
  all,
  horizontal,
  vertical,
  top,
  right,
  bottom,
  left,
  children,
}) => {
  // remove undefined values before passing to Box
  const boxProps = {
    ...(all && { padding: all }),
    ...(horizontal && { paddingX: horizontal }),
    ...(vertical && { paddingY: vertical }),
    ...(top && { paddingTop: top }),
    ...(right && { paddingRight: right }),
    ...(bottom && { paddingBottom: bottom }),
    ...(left && { paddingLeft: left }),
  };
  return <Box {...boxProps}>{children}</Box>;
};

export default Padding;
